<template>
  <header class="app-header navbar pl-0">
    <Alerts />
    <b-col sm="auto" class="pl-0 mr-auto">
      <ul class="nav navbar-nav">
        <!-- <button
          class="navbar-toggler mobile-sidebar-toggler d-lg-none"
          type="button"
          @click="mobileSidebarToggle"
        >
        <span class="navbar-toggler-icon"></span>
        </button> -->
        <li class="top-nav nav-item px-2" v-if="showSupreme">
          <router-link to="/enterprise-features" class="nav-link text-upper">
            Enterprise Features
            <!-- <img src="/images/new.png" style="width: 30px; margin: -20px 0 0 -5px;" /> -->
          </router-link>
        </li>
        <li class="top-nav nav-item px-2">
          <router-link to="/help/postal" class="nav-link text-upper">Postal Connect</router-link>
        </li>
        <li class="top-nav nav-item px-2">
          <router-link to="/help/how-to" class="nav-link text-upper">
            How-To Videos
          </router-link>
        </li>
        <!-- <b-nav-item-dropdown v-if="user.role && user.role.admin && showSupreme" class="top-nav nav-item px-2">
          <template slot="button-content">
            <i class="fa fa-lock"></i> Admin
          </template>
          <router-link to="/admin/users" class="dropdown-item">Users</router-link>
        </b-nav-item-dropdown> -->
      </ul>
    </b-col>
    <b-col sm="auto" class="ml-auto">
      <b-navbar-nav class="pull-right mr-sm-4 mr-lg-0" style="font-size: 0.80rem !important;">
        <!-- <b-nav-item :class="['notification']">
          <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none">
            <template slot="button-content">
              <i :class="['fa', notifications.length == 0 ? 'fa-bell-o text-light' : 'fa-bell text-warning']"></i>
              <span class="text-warning">{{ notifications.length || '' }}</span>
            </template>
            <a
              v-if="notifications.length > 0"
              class="float-right mr-2 read"
              @click="readAllNotifications"
            >Mark all as read</a>
            <b-dropdown-text class="text-center mb-2" v-if="notifications.length == 0">No notification</b-dropdown-text>
            <b-dropdown-item v-for="n in notifications" :key="n.id" @click="goToNotification(n)">
              {{ n.message|truncate }} - {{ n.created_at|ago }}
            </b-dropdown-item>
          </b-dropdown>
        </b-nav-item> -->
        <b-nav-text class="ml-2 text-light" href="#/my-account/balance" v-if="1" style="padding: 0; font-size: 14px;">
          <div class="d-flex flex-column">
            <!-- <img
              src="/images/icon-balance.png"
              class="mr-1"
              style="width: auto;
                height: 0.80rem;
                vertical-align: top;"
            /> -->
            <span id="pb-balance" class="d-flex justify-content-between">
              <i class="fa-solid fa-circle-dollar-to-slot" style="margin-top: 4px; margin-right: 2px"></i>
              <span>{{formatPrice(balance)}}</span>
            </span>
            <span id="shipsurance-balance" class="d-flex justify-content-between" v-if="user.shipsurance_terms">
              <i class="fa-solid fa-shield" style="margin-top: 4px; margin-right: 2px"></i>
              <span>{{formatPrice(shipsurance)}}</span>
            </span>
          </div>
          <b-tooltip target="pb-balance" triggers="hover">Postage balance</b-tooltip>
          <b-tooltip target="shipsurance-balance" triggers="hover">Shipsurance balance</b-tooltip>
        </b-nav-text>
        <HeaderPrintService />
        <HeaderDropdownAccnt />
      </b-navbar-nav>
    </b-col>
  </header>
</template>

<style lang="scss">
.notification {
  position: relative;

  .read,
  .read:hover {
    text-decoration: underline !important;
  }

  span {
    position: absolute;
    top: -3px;
    font-size: .75rem;
  }

  .dropdown-menu {
    transform: translate(-47%, 24px) !important;
    max-height: 310px;
    overflow: auto;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .dropdown-item.active,
  .dropdown-item:active {
    background-color: transparent;
  }
}
</style>

<script>
import HeaderPrintService from "./Header/HeaderPrintService.vue";
import HeaderDropdownAccnt from "./Header/HeaderDropdownAccnt.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import formatters from "../formatters";
import Alerts from "./Alerts";

export default {
  name: "c-header",
  data() {
    return {
      showSupreme: true,
    }
  },
  components: {
    HeaderPrintService,
    HeaderDropdownAccnt,
    Alerts
  },
  props: ["usr"],
  created() { },
  mounted() {
    console.log('employee', this.employee);
    this.showSupreme = (this.employee) ? false : true;
    console.log('subscription', this.user.subscription);
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    ...mapGetters({
      balance: "getUserBalance",
      employee: "getEmployeeName",
      notifications: "getNotification",
      shipsurance: "getShipsurance",
    })
  },
  methods: {
    ...mapActions(["refreshNotification"]),
    formatPrice: formatters.price,
    sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-minimized");
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
    },
    leftMenuToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
    },

    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
    },

    async goToNotification(notif) {
      // update notifcation status to read and redirect to its url
      console.log('updating notifcation', notif);
      try {
        await axios.post('/user/notification', { notification_id: notif.id })
        await this.refreshNotification();
        this.$router.push(notif.url)
      } catch (error) {
        this.$emit("alert", {
          message: "Notification not found.",
          type: "danger"
        });
      }
    },

    async readAllNotifications() {
      console.log('marking all notification as read');
      try {
        await axios.post('/user/notification/read')
        await this.refreshNotification();
      } catch (error) {
        console.log('error marking all as read', error);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header.vue